var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"verify-email"},[_c('NhstValidateCodeAndChangePassword',{attrs:{"description":_vm.description},on:{"loggedInSuccess":_vm.onEmailVerified}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }